var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contribution-page"},[_c('div',{staticClass:"font20 font-bold mt-3 mb-3 text-left"},[_vm._v(_vm._s(_vm.$t('cl.crowdloan')))]),_c('DashboardCard',{attrs:{"chain":"rococo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }